<template>
  <div class="container pt-5 mt-2">
    <!--          上部分 -->
    <div class="vali-detail">

      <!--          左部分-->
      <div class="address-box-left vali-box-left">
        <div class="d-flex flex-row align-items-center justify-content-between w-100">
          <div class="d-flex flex-row align-items-center">
            <div class="address-box-icon">
              <img src="../../images/validators/validators.png"/>
            </div>
            <span class="ml-1 vali-box-top-text">Voter</span>
          </div>
        </div>

        <div class="vali-top-name">
          <div class="vali-top-name-item">
            <span>Name</span>
            <span></span>
          </div>
          <div class="vali-top-name-item">
            <span>Address</span>
            <span class="fontcolor-blue">{{address}}</span>
          </div>
        </div>


      </div>
      <!--          右部分-->
      <div class="address-box-right vali-box-right">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <span></span>
          <div class="vali-box-top">
            <div class="vali-box-top-round"></div>
            <span>Voter Information</span>
          </div>
        </div>
        <div class="vali-top-name pt-4">
          <div class="vali-top-name-item">
            <span>Reward</span>
            <span>{{validatorDetail.rewardAmount}}</span>
          </div>
          <div class="vali-top-name-item">
            <span>VoteAmount</span>
            <span>{{parseFloat(validatorDetail.voteAmount).toFixed(6)}}</span>
          </div>
          <div class="vali-top-name-item">
            <span>Voted Validators</span>
            <span>{{validatorDetail.voteValidatorAmount}}</span>
          </div>
        </div>
      </div>

    </div>
    <!--            下部分-->
    <div class="address-tab">
      <div @click="showTab=0" :class="showTab==0 ?'address-tab-text-click':''"  class="address-tab-text address-tab-text-one">Transactions</div>
      <div @click="showTab=1" :class ="showTab==1 ?'address-tab-text-click':''"   class="address-tab-text address-tab-text-six">Rewards</div>
      <!--            <div @click="showTab=3" :class ="showTab==3 ?'address-tab-text-click':''"   class="address-tab-text address-tab-text-severn">Voter Rewards</div>-->
      <div @click="showTab=2" :class="showTab==2 ?'address-tab-text-click':''"  class="address-tab-text address-tab-text-voters" >Votes</div>
    </div>

    <!--          transaction-->
    <div v-show="showTab==0" class="mt-4">
      <ValidatorTransaction v-if="address" :cfg="cfg" :page="showPage" :type="2" :address="address"/>
    </div>

    <!--          Rewards-->
    <div v-show="showTab==1">
         <VoterRewards :version="validatorDetail.version" :address="address"  v-if="address" :cfg="cfg" :page="showPage" :top="1"/>
    </div>

    <!--          Delegators-->
    <div  v-show="showTab==2">
      <VotersTable :version="validatorDetail.version" :address="address"  v-if="address" :cfg="cfg" :page="showPage" :top="1"/>
    </div>

    <!--          voter rewards-->
    <!--          <div  v-show="showTab==3">-->
    <!--            <VoterRewards :version="validatorDetail.version" :address="address"  v-if="address" :cfg="cfg" :page="showPage" :top="1"/>-->
    <!--          </div>-->

  </div>
</template>

<script>
import { Decimal } from 'decimal.js'
import TransactionTable from "@/views/comp_table/transaction_table";
import TokenTable from "@/views/comp_table/tokens_table";
import Copy from "@/views/_frame/copy";
import {updateAddress,getSortAddress} from "@/util";
import AccountInternalTxnsTable from "@/views/comp_table/account_internal_txs";
import TokenInventory from "@/views/_comp_token/token_inventory_table";
import RewardsTable from "@/views/comp_table/rewards_table";
import DelegatorsTable from "@/views/comp_table/delegators_table";
import VoterRewards from "@/views/comp_table/voter_rewards_table";
import VotersTable from "@/views/comp_table/voters_table";
import ValidatorTransaction from "@/views/comp_table/validator_transaction_table";

export default {
  name: "VoterDetail",
  components: {
    ValidatorTransaction,
    VotersTable,
    VoterRewards,
    DelegatorsTable,
    RewardsTable,
    TokenInventory,
    AccountInternalTxnsTable,
    Copy, TokenTable, TransactionTable},
  data() {
    return {
      cfg:{
        'page_size': 10, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 0, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      validatorDetail: [],//委员会详情
      address:'',//显示地址
      showPage:'showPage',//显示页码
      showTab:0,
      transList: null,//交易列表
      transTotal:0,//交易总数
      ercTransList:null,//erc20列表
      ercSevenTransList:null,//erc721列表
      tokenList:null,//token列表
      internalList:null,//internal列表
    }
  },
  methods:{
    //转换地址
    updateAddress(val){
      if (!val) {
        return
      }
      return  updateAddress(val)
    },
    getSortAddress(val){
      return getSortAddress(val)
    },
    //账户详情显示
    async actionAccount(){
      let v = this
      let address = {'address': v.address}
      let result=await v.api('queryVoterInfo',address,{ vue: v,
        key_data: 'data',})
      // console.log('addressDetail',result)
      if (result.code==200){
        v.validatorDetail=result.data
      }
    },

    getAllData() {
      this.actionAccount()
    }
  },
  mounted() {
    this.address=this.$route.params.number
    this.getAllData()
  },
}
</script>

<style scoped lang="scss">

.vali-box-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    margin-top: 2px;
    padding-left: 10px;
    font-size: 18px;
    font-weight: bold;
    color: rgb(55, 114, 255);
  }
}

.vali-box-top-two {
  padding-top: 11px;
}

.vali-box-top-round {
  width: 6px;
  height: 6px;
  background: #3772ff;
  border-radius: 50%;
}

.vali-detail {
  width: 100%;
  height: 286px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding:0 41px;
  background: url("../../images/validators/box-bg-f.png")no-repeat;
  background-size: 100% 100% ;
}



.vali-box-top-text {
  padding-left: 20px;
  font-size: 22px;
  font-weight: bold;
}

.vali-box-right {
  width: 50%;
  margin-left: 121px;
  padding-top: 48px;
}

.vali-top-name {
  padding-top: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vali-top-name-item {
  padding-top: 33px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  span:nth-child(1) {
    font-size: 13px;
    font-weight: bold;
  }
  span:nth-child(2) {
    opacity: 0.7;
    font-size: 13px;
  }
}

.vali-top-name-item:nth-child(1) {
  padding-top: 0;
}

.vali-box-left {
  width: 36%;
}

</style>
